import { type DataGridColumn, RowItem } from '../components/comp-data-grid/comp-data-grid.models';
import { CloneHelper } from "../helpers/clone.helper";

export enum DataType {
    Default = 1,
    Boolean = 2,
    Number = 3,
    Double = 4,
    Color = 5,
    Image = 6,
    Date = 7,
    Lookup = 8,
    HierarchicalLookup = 9,
    Icon = 10,
    CustomTemplate = 11,
    DateTime = 12,
    Password = 13,
    Button = 15,
    Expander = 16,
    ComboBox = 17,
    Radio = 18,
    Time = 19,
    EntityFinder = 20,
    //DO NOT REMOVE THESE DURING MERGE FROM GENESIS
    RangeSelector = 1000,
    CheckedLookupSelector = 1001,
    CheckedListSelector = 1002,
    RatingSelector = 1003,
    GHGRatingSelector = 1004,
    MultiLookupSelector = 1005,
    DateRange = 1006,
    Many2Many = 1007
}


export class ItemSource {

    //The Source Type is the type of the source as an ODataUrl or an Array or something else.
    sourceType: SourceType;

    //This is the raw source that can be a string url or a collection
    source: any | any[];

    //these are the columns may be null
    columns?: DataGridColumn[];

    //these are the initial filters applied to the collection
    initialSorting?: DataGridColumn[];

    //these are the initial filters applied to the collection, used for API calls
    filter?: any;

    serverSideSorting?: boolean;

    widths?: { [column: string]: string };

    limit?: number;

    propertyDefaults?: { [propertyName: string]: any };

    getRowClass?: (item: any, rowItem: RowItem) => string;
}

export enum SourceType {
    Collection,
    ODataUrl
}

export class QueryFilter {
    // public selectedModel?: EntityMetaDataModel;
    public filterOperator: EntityMetaDataModelOperator;
    public filterValue: any = undefined;
    public isAnd?: boolean;
    public aggregateOperator?: number;
    public joiningClause?: JoiningPropertyModel;
    public isLast?: boolean;
    public isReadonly?: boolean;
    public uri?: string;
    public isAggregate?: boolean;
    public selectedForGrouping?: boolean;
    public groupColor?: string;
    public groupGuid?: string;
    public subGroupGuid?: string;
    public filterProperty: EntityFilterPropertyModel;
    public orderByProperty?: EntityFilterPropertyModel;
    public skipOnNullOrEmpty: boolean = true;
    public filterContextPropertyValue?: any;
    public previousValue?: any;
    public originalValue?: any;

    public static getQuery(propertyName: string,
        value: any,
        symbolOperator,
        type: DataType,
        isAnd: boolean = false,
        isLast: boolean = false,
        groupGuid: string = null,
        selectedForGrouping: boolean = false,
        requiresInterpolation: boolean = false): QueryFilter {
        return <QueryFilter>{
            filterProperty: { name: propertyName, type },
            filterOperator: { translatedSymbol: symbolOperator, requiresInterpolation: requiresInterpolation, requiresFilterValue: true },
            filterValue: value,
            isAnd,
            isLast,
            groupColor: null,
            groupGuid,
            selectedForGrouping,
            skipOnNullOrEmpty: true
        };
    }

    public static clone(x: QueryFilter): QueryFilter {
        const clonedCopy = CloneHelper.clone(x);
        const result: QueryFilter = new QueryFilter();
        result.filterOperator = clonedCopy.filterOperator;
        result.filterValue = clonedCopy.filterValue
        result.isAnd = clonedCopy.isAnd;
        result.isLast = clonedCopy.isLast;
        result.selectedForGrouping = clonedCopy.selectedForGrouping;
        result.groupColor = clonedCopy.groupColor;
        result.groupGuid = clonedCopy.groupGuid;
        result.filterProperty = clonedCopy.filterProperty;
        result.filterContextPropertyValue = clonedCopy.filterContextPropertyValue;
        result.uri = clonedCopy.uri;

        return result;
    }
}

export interface EntityMetaDataModelOperator {
    friendlyName?: string;
    translatedSymbol: string;
    supportedTypes?: DataType[];
    supportedTypesForCollectionProperties?: DataType[];
    requiresInterpolation?: boolean;
    isOnlyForNullableProperties?: boolean;
    requiresFilterValue?: boolean;
}

export interface JoiningPropertyModel {
    friendlyName:string;
    joiningProperty:string;
    joiningVetContextProperty:string;
}

export interface EntityFilterPropertyModel {
    name?: string;
    friendlyName?: string;
    type?: DataType;
    lookupMappedToProperty?: string;
    lookupParametersMappedToProperty?: string;
    entityFinderMappedToProperty?: string;
    isNullable: boolean;
    isDynamicProperty: boolean;
    startLabel?: string;
    endLabel?: string;
    isUpdatable?: boolean;
    isCollection?: boolean;
    tags?: string;
    format?: string;
}

export interface DataGridColumnOverride {
    property?: string;
    valueConverter?: (value, item: any, params?: any) => any;
    getComponentClass?: (item: any) => string;
    getCellInlineStyles?: (item: any) => string;
    getCellClass?: (item: any) => string;
    titleToolTip?: string;
}